import { MessageSquare } from 'lucide-react';
import { href } from '../../lib/router';
import { useThread } from './api';

/** A link to the assessment's messages, with how many are new for this person. */
export function MessagesLink({ id, className = 'btn' }: { id: string; className?: string }) {
  const t = useThread(id);
  const unread = t.data?.unread ?? 0;
  return (
    <a className={className} href={href.messages(id)}>
      <MessageSquare size={15} /> Messages
      {unread > 0 && (
        <span className="count-badge" aria-label={`${unread} new`}>
          {unread}
        </span>
      )}
    </a>
  );
}
